<template>
    <b-tabs card>
      <b-tab title="Profile data">
        <b-card-text>
          <table class="table">
          <tbody>
            <tr>
              <td>Login</td>
              <td>{{account.login}}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{account.firstName}} {{account.lastName}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{account.email}}</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>{{account.langKey}}</td>
            </tr>
            <tr v-if="account.organization">
              <td>Organization</td>
              <td>{{account.organization.name}}</td>
            </tr>
          </tbody>
          </table>
          <!-- <b-button>Edit</b-button> -->
        </b-card-text>

      </b-tab>

      <b-tab title="Author profile">
        <Error></Error>
        <ResearchProfileView v-if="hasResearchProfiles && researchProfile.profileSources && !editMode"
          v-bind:profile="researchProfile" @updatePublications="editMode = true"
        ></ResearchProfileView>
        <ResearchProfileEdit v-else-if="hasResearchProfiles && researchProfile.profileSources && editMode"
          v-bind:profile="researchProfile" @cancelEdit="editMode = false">
        </ResearchProfileEdit>

        <ResearchProfileCreate v-else-if="hasResearchProfiles && !researchProfile.profileSources" v-bind:profile="researchProfile"  @selectPublications="editMode = true"
        ></ResearchProfileCreate>

        <LoadingPublications v-else-if="showFetchProfileScreen" v-bind:profile="researchProfile"
        ></LoadingPublications>

        <div v-else>
          <b-button v-on:click.prevent="createProfile">Create profile</b-button>
        </div>
      </b-tab>

    </b-tabs>
</template>

<script>
import ResearchProfileView from '@/components/ResearchProfileView'
import ResearchProfileEdit from '@/components/ResearchProfileEdit'
import ResearchProfileCreate from '@/components/ResearchProfileCreate'
import LoadingPublications from '@/components/LoadingPublications'
import Error from '@/components/Error'

export default {
  name: 'UserProfile',
  components: {
    ResearchProfileView,
    ResearchProfileEdit,
    ResearchProfileCreate,
    LoadingPublications,
    Error
  },
  data() {
    return {
      editMode: false
    }
  },
  created: function () {
      this.$store.dispatch('fetchAccount');
  },
  computed: {
    account () {
      return this.$store.state.account;
    },
    hasResearchProfiles () {
      return (this.$store.state.researchProfiles && this.$store.state.researchProfiles.length > 0 );
    },
    showFetchProfileScreen() {
      return this.$store.state.showFetchProfileScreen;
    },
    researchProfile () {
      // right now we are only supporting one profile, so returning the first research profile
      if (this.$store.state.researchProfiles && this.$store.state.researchProfiles.length > 0 ) {
        return this.$store.state.researchProfiles[0];
      } else {
        return '';
      }
    },
    researchProfilePublicationsLength () {
      // right now we are only supporting one profile, so returning the number of publications of the first research profile
      if (this.$store.state.researchProfiles && this.$store.state.researchProfiles.length > 0 ) {
        if (this.$store.state.researchProfiles[0].publications)
          return this.$store.state.researchProfiles[0].publications.length;
      }
      return 0;

    }
  },
  methods: {
    createProfile(){
      this.$store.dispatch('createResearchProfile')
    }
  }

}
</script>
<style scoped>
</style>
